// @flow
import RecentTxTable from './RecentTxTable'

export default RecentTxTable



// WEBPACK FOOTER //
// ./src/components/RecentTxTable/index.js